import { load3DLogo } from '../../vendor/index.js';

export default {
  init() {
    /* Script pour le module vidéo avec curseur, preview et ligne élastique */
    if ($(".module-calculator-price-testimonials")[0]) {
      $('.module-calculator-price-testimonials .block_wrapper_testimonials .testimonials').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });
    }
  },
};
